import styled, { css } from 'styled-components'
// components
import Grid from '@mui/material/Grid2'
import MaterialAppBar from '@mui/material/AppBar'
// constants
import { CLOSED_DRAWER_WIDTH, DRAWER_WIDTH } from 'constants/layout'
// themes
import { colors } from 'themes/index'

export const StyledAppBar = styled(({ $isExpanded, $isPlanEdit, ...props }) => <MaterialAppBar {...props} />)<{
  $isExpanded: boolean
  $isPlanEdit: boolean
}>`
  && {
    align-items: center;
    background-color: ${colors.darkBlue500};
    color: ${colors.gray850};
    display: flex;
    flex-direction: row;
    height: 64px;
    justify-content: space-between;
    padding: ${({ $isPlanEdit }) => `0 ${$isPlanEdit ? '20px' : '42px'} 0 16px`};
    width: calc(100% - ${CLOSED_DRAWER_WIDTH}px);
    z-index: 99;
    transition:
      width,
      margin 200ms cubic-bezier(0.4, 0, 0.2, 1);

    ${({ $isExpanded }) =>
      $isExpanded &&
      css`
        margin-left: ${DRAWER_WIDTH};
        width: calc(100% - ${DRAWER_WIDTH}px);
      `};

    @media (max-width: 768px) {
      padding: 16px;
      box-shadow: none;
      width: calc(100% - 72px);
    }
  }
`

export const LeftPart = styled(Grid)`
  && {
    color: ${colors.white};
    font-size: 24px;
    font-weight: 500;
    overflow: hidden;
  }
`

export const RightPart = styled(Grid)`
  && {
    width: auto;
    gap: 16px;
  }
`
